import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const state = {
  layers: {},
  subLayers: {},
  //layersSorted: [],
  activeLayersOnInit: [],
  fetchedLayersFromPhase: [] // IDs of phases where the layers were fetched completely
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
